export const setPriceColor = (realtyOfferId: number, activePin?: number) => {
  const pricePin = document.getElementById(String(realtyOfferId));

  if (!pricePin) {
    return;
  }

  if (realtyOfferId === activePin) {
    pricePin.style.backgroundColor = 'var(--primary_100)';
    pricePin.style.color = 'white';
  } else {
    pricePin.style.backgroundColor = 'white';
    pricePin.style.color = 'black';
  }
};
